import { render, staticRenderFns } from "./myProgramPackPage.vue?vue&type=template&id=3f8e2247&"
import script from "./myProgramPackPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPackPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports